import Input from "@aleaplay/web-components/ui/Input";

import { FormChild } from "@/v1/components/atoms/FormChild";
import { useTranslation } from "@/v2/hooks/useTranslation";
import { getEmailValidation } from "@/v2/service/getEmailValidation";

export const NewsletterEmailField = () => {
  const { t } = useTranslation();
  return (
    <FormChild>
      <Input
        name="email"
        errors={{
          required: t("generic-input.error"),
          checkCorrectValue: [
            (value: string) => {
              return getEmailValidation(value);
            },
            t("label.email-format-error"),
          ],
        }}
        label={t("label.email")}
        placeholder={t("placeholder.email")}
      />
    </FormChild>
  );
};
